
// eslint-disable-next-line import/no-unresolved
import React from "react";
import { ThemeProvider } from "styled-components";
import ErrorBoundary from "./ErrorBoundary";
import StyledGlobal from "./StyledGlobal";
import PropTypes from "prop-types";

const AppBase = ({ children, theme }) => (
  <ThemeProvider theme={theme}>
    <ErrorBoundary>
      <StyledGlobal theme={theme} />

      {children}
    </ErrorBoundary>
  </ThemeProvider>
);

AppBase.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({}).isRequired,
};

export default AppBase;
